<!-- eslint-disable vue/no-unused-components -->
<!-- eslint-disable vue/no-multiple-template-root -->
 <!--Designed & Developed by:
    Nirmal K (@cyberwizard1001)⁶
    Nitin Ravi (@nitinravi)
    Ritwik M (@ritwik-m) &
    Nalinadevi K 
 for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->

<script>

import abstractComponent from "../components/help/abstractComponent.vue";
import arrayListComponent from "../components/help/arrayListComponent.vue";
import classCastExceptionComponent from "../components/help/classCastExceptionComponent.vue";
import constructorWritingComponent from "../components/help/constructorWritingComponent.vue";
import dateComponent from "../components/help/dateComponent.vue";
import extendsComponent from "../components/help/extendsComponent.vue";
import functionCallingWithObjectComponent from "../components/help/functionCallingWithObjectComponent.vue";
import getterComponent from "../components/help/getterComponent.vue";
import interfaceComponent from "../components/help/interfaceComponent.vue";
import newVariableComponent from "../components/help/newVariableComponent.vue";
import nullPointerExceptionComponent from "../components/help/nullPointerExceptionComponent.vue";
import objectCreationComponent from "../components/help/objectCreationComponent.vue";
import parseExceptionComponent from "../components/help/parseExceptionComponent.vue";
import passingArgumentsToFunctionsComponent from "../components/help/passingArgumentsToFunctionsComponent.vue";
import printFunctionComponent from "../components/help/printFunctionComponent.vue";
import setterComponent from "../components/help/setterComponent.vue";
import stringCompareComponent from "../components/help/StringcompareComponent.vue";
import superKeywordComponent from "../components/help/superKeywordComponent.vue";
import thisComponent from "../components/help/thisComponent.vue";
import tryCatchComponent from "../components/help/tryCatchComponent.vue";


export default {
	components: {
    abstractComponent,
    arrayListComponent,
    classCastExceptionComponent,
    constructorWritingComponent,
    dateComponent,
    extendsComponent,
    functionCallingWithObjectComponent,
    getterComponent,
    interfaceComponent,
    newVariableComponent,
    nullPointerExceptionComponent,
    objectCreationComponent,
    parseExceptionComponent,
    passingArgumentsToFunctionsComponent,
    printFunctionComponent,
    setterComponent,
    stringCompareComponent,
    superKeywordComponent,
    thisComponent,
    tryCatchComponent,
  },
  methods: {
	popup(chosenComponent) {
      this.currentComponent = chosenComponent;
      console.log("popup")
      var modal = document.getElementById("myModal");
      console.log(modal)
      var span = document.getElementsByClassName("close")[0];
        modal.style.display = "block";
        console.log(modal.style.display)
      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = "none";
      }

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      }
    },
    correct1() {
      var x = document.getElementById("snackbar");
      x.innerHTML = "Correct";
      x.style.backgroundColor = "green";
      x.className = "show";
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000)
    },
    incorrect() {
      var x = document.getElementById("snackbar");
      x.innerHTML = "Inorrect. Try again";
      x.style.backgroundColor = "red";
      x.className = "show";
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000)
    },
    validate_one() {
      if (this.one == "Iterator" && this.two == "hasNext") {
        this.correct1();
        this.display[0] = "none";
        this.display[1] = "block";
      } else {
        this.incorrect();
      }
    },

    validate_two() {
      if (this.three == "Customer" && this.four == "next") {
        this.correct1();
        this.display[1] = "none";
        this.display[2] = "block";
        //this.$emit('testDriver', true);
      } else {
        this.incorrect();
      }
    },

    validate_three(){
        this.display[2] = "none";
        this.display[3] = "block";
    },

    validate_four(){
        this.display[3] = "none";
        this.display[4] = "block";
        this.$emit('testDriver', true);
    },

  },
  data() {
    return {
      id: 'container',
      class: 'wrapper',
      button_value: 'Next',
      currentComponent: 'constructorWritingComponent',
      button_text: "Incorrect. Try again",
      button_text_right: "Correct. Next",
      correct: false,
      display: ["block", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none",]
    }
  }

}

</script>
<template>
  <main class="app">
    <div id="snackbar">Some text some message..</div>

    <div class="row">

      <div class="column" style="position:sticky; top: 30%; left: 65%; bottom: 10%; float: right">
       <div class="column">
         <div class="codebox">
           <h5>Test Driver: </h5>
           <ul style="line-height: 125%;">
             <li>Write a TestDriver class that has a singleton RentalSystem object.</li>
             <li>Create an object of type PersonFactory</li>
             <li>Create execobj and cobj arrays of type Exec and Customer respectively 
              and initialise them with appropriately casted PersonFactory objects.</li>
              <li>Set the city of the customer objects as mentioned in the comments.</li>
              <li>Create a vehicle object with a registration number. </li>
              <li>Create a Reservation object and use it to set the booking date and contract status.</li>
             <li>Print a list of all Customers by using an Iterator.</li>
             <li>Similarly, print a list of all Execs, Vehicles and Reservations by using an Iterator</li>
             <li>Call the visitOffice method by passing the correct object as parameter.</li>
           </ul>
         </div>
       </div>
     </div>

      <div class="column">
        <h1 style="padding: 25px; padding-bottom: 0px;">Understanding Iterator Usage - Test Driver Construction</h1>
        <p style="padding: 25px; padding-top: 0px">Call the iterator functions written earlier to print a list of all involved objects to understand their usage</p>

        <div class="codebox" id="codebox" :style="{ display: display[0] }">
           <pre>
import java.util.Scanner;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		//RentalSystem rentalSystem = new RentalSystem();
		//Singleton Pattern Demo
		RentalSystem rentalSystem = RentalSystem.getRentalSystem();
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=new Person.PersonBuilder("EFG")
				.withEmail("efg@gmail.com")
				.withCity("Coimbatore")
				.buildExec();
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=new Person.PersonBuilder("ABC")
				.withEmail("abc@gmail.com")
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[1]=new Person.PersonBuilder("DEF")
				.withPhone(8654678976L)
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[2]=new Person.PersonBuilder("GHI")
				.withEmail("ghi@gmail.com")
				.withPhone(1234567890L)
				.withCity("Chennai")
				.buildCustomer();
		
		rentalSystem.vobj = new Vehicle[1];
		rentalSystem.vobj[0]=new Vehicle(1234);
		
		rentalSystem.robj=new Reservation[1];
		rentalSystem.robj[0]= new Reservation(rentalSystem.cobj[0],rentalSystem.vobj[0]);
		SimpleDateFormat sdformat = new SimpleDateFormat("yyyy-MM-dd");
    Date d = sdformat.parse("2022-02-29");
		rentalSystem.robj[0].setBookingDate(d);
		rentalSystem.robj[0].setContractStatus("Reservation not released");
		
		System.out.println("Customer list: ");
</pre>
&emsp;&emsp;&emsp;for(<input type="text" v-model="one" style="width:80px" maxlength="8"> iter = rentalSystem.getIterator("customer"); iter.<input spellcheck="false" style="width: 80px;" id="two" v-model="two" maxlength="7">();)<br>
&emsp;&emsp;&emsp;{<br>&emsp;&emsp;&emsp;//content
    <br>&emsp;&emsp;&emsp;}
<p id="comment">//Create an Iterator iter within the for loop until it has a next element.</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_one()"> {{ button_value }}</button>
        </div>

        
        <div class="codebox" id="codebox" :style="{ display: display[1] }">
           <pre>
import java.util.Scanner;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		//RentalSystem rentalSystem = new RentalSystem();
		//Singleton Pattern Demo
		RentalSystem rentalSystem = RentalSystem.getRentalSystem();
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=new Person.PersonBuilder("EFG")
				.withEmail("efg@gmail.com")
				.withCity("Coimbatore")
				.buildExec();
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=new Person.PersonBuilder("ABC")
				.withEmail("abc@gmail.com")
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[1]=new Person.PersonBuilder("DEF")
				.withPhone(8654678976L)
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[2]=new Person.PersonBuilder("GHI")
				.withEmail("ghi@gmail.com")
				.withPhone(1234567890L)
				.withCity("Chennai")
				.buildCustomer();
		
		rentalSystem.vobj = new Vehicle[1];
		rentalSystem.vobj[0]=new Vehicle(1234);
		
		rentalSystem.robj=new Reservation[1];
		rentalSystem.robj[0]= new Reservation(rentalSystem.cobj[0],rentalSystem.vobj[0]);
		SimpleDateFormat sdformat = new SimpleDateFormat("yyyy-MM-dd");
    Date d = sdformat.parse("2022-02-29");
		rentalSystem.robj[0].setBookingDate(d);
		rentalSystem.robj[0].setContractStatus("Reservation not released");
		
		System.out.println("Customer list: ");
		for(Iterator iter = rentalSystem.getIterator("customer"); iter.hasNext();)
		{

</pre>
&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;Customer cobj = (<input type="text" v-model="three" style="width: 85px" maxlength="8">) iter.<input spellcheck="false" style="width: 50px;" id="four" v-model="four" maxlength="4">();<br>
<br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;System.out.println(cobj.toString());
<p id="comment">//Assign the iterator's next value to the customer object</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_two()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[2] }">
           <pre>
import java.util.Scanner;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		//RentalSystem rentalSystem = new RentalSystem();
		//Singleton Pattern Demo
		RentalSystem rentalSystem = RentalSystem.getRentalSystem();
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=new Person.PersonBuilder("EFG")
				.withEmail("efg@gmail.com")
				.withCity("Coimbatore")
				.buildExec();
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=new Person.PersonBuilder("ABC")
				.withEmail("abc@gmail.com")
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[1]=new Person.PersonBuilder("DEF")
				.withPhone(8654678976L)
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[2]=new Person.PersonBuilder("GHI")
				.withEmail("ghi@gmail.com")
				.withPhone(1234567890L)
				.withCity("Chennai")
				.buildCustomer();
		
		rentalSystem.vobj = new Vehicle[1];
		rentalSystem.vobj[0]=new Vehicle(1234);
		
		rentalSystem.robj=new Reservation[1];
		rentalSystem.robj[0]= new Reservation(rentalSystem.cobj[0],rentalSystem.vobj[0]);
		SimpleDateFormat sdformat = new SimpleDateFormat("yyyy-MM-dd");
    Date d = sdformat.parse("2022-02-29");
		rentalSystem.robj[0].setBookingDate(d);
		rentalSystem.robj[0].setContractStatus("Reservation not released");
		
		System.out.println("Customer list: ");
		for(Iterator iter = rentalSystem.getIterator("customer"); iter.hasNext();)
		{
        Customer cobj = (Customer) iter.next();
        System.out.println(cobj.toString());
    }
		
		System.out.println("Exec list: ");
		for(Iterator iter = rentalSystem.getIterator("exec"); iter.hasNext();)
		{
        Exec cobj = (Exec) iter.next();
        System.out.println(cobj.toString());
    }
		
</pre>
<button class="button-9" id="btn1" @click="validate_three()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[3] }">
           <pre>
import java.util.Scanner;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		//RentalSystem rentalSystem = new RentalSystem();
		//Singleton Pattern Demo
		RentalSystem rentalSystem = RentalSystem.getRentalSystem();
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=new Person.PersonBuilder("EFG")
				.withEmail("efg@gmail.com")
				.withCity("Coimbatore")
				.buildExec();
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=new Person.PersonBuilder("ABC")
				.withEmail("abc@gmail.com")
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[1]=new Person.PersonBuilder("DEF")
				.withPhone(8654678976L)
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[2]=new Person.PersonBuilder("GHI")
				.withEmail("ghi@gmail.com")
				.withPhone(1234567890L)
				.withCity("Chennai")
				.buildCustomer();
		
		rentalSystem.vobj = new Vehicle[1];
		rentalSystem.vobj[0]=new Vehicle(1234);
		
		rentalSystem.robj=new Reservation[1];
		rentalSystem.robj[0]= new Reservation(rentalSystem.cobj[0],rentalSystem.vobj[0]);
		SimpleDateFormat sdformat = new SimpleDateFormat("yyyy-MM-dd");
    Date d = sdformat.parse("2022-02-29");
		rentalSystem.robj[0].setBookingDate(d);
		rentalSystem.robj[0].setContractStatus("Reservation not released");
		
		System.out.println("Customer list: ");
		for(Iterator iter = rentalSystem.getIterator("customer"); iter.hasNext();)
        Customer cobj = (Customer) iter.next();
        System.out.println(cobj.toString());
    }
		
		System.out.println("Exec list: ");
		for(Iterator iter = rentalSystem.getIterator("exec"); iter.hasNext();)
		{
        Exec cobj = (Exec) iter.next();
        System.out.println(cobj.toString());
    }
		
		System.out.println("Vehicle list: ");
		for(Iterator iter = rentalSystem.getIterator("vehicle"); iter.hasNext();)
		{
        Vehicle cobj = (Vehicle) iter.next();
        System.out.println(cobj.toString());
    }
</pre>
<button class="button-9" id="btn1" @click="validate_four()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[4] }">
           <pre>
import java.util.Scanner;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		//RentalSystem rentalSystem = new RentalSystem();
		//Singleton Pattern Demo
		RentalSystem rentalSystem = RentalSystem.getRentalSystem();
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=new Person.PersonBuilder("EFG")
				.withEmail("efg@gmail.com")
				.withCity("Coimbatore")
				.buildExec();
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=new Person.PersonBuilder("ABC")
				.withEmail("abc@gmail.com")
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[1]=new Person.PersonBuilder("DEF")
				.withPhone(8654678976L)
				.withCity("Coimbatore")
				.buildCustomer();
		rentalSystem.cobj[2]=new Person.PersonBuilder("GHI")
				.withEmail("ghi@gmail.com")
				.withPhone(1234567890L)
				.withCity("Chennai")
				.buildCustomer();
		
		rentalSystem.vobj = new Vehicle[1];
		rentalSystem.vobj[0]=new Vehicle(1234);
		
		rentalSystem.robj=new Reservation[1];
		rentalSystem.robj[0]= new Reservation(rentalSystem.cobj[0],rentalSystem.vobj[0]);
		SimpleDateFormat sdformat = new SimpleDateFormat("yyyy-MM-dd");
    Date d = sdformat.parse("2022-02-29");
		rentalSystem.robj[0].setBookingDate(d);
		rentalSystem.robj[0].setContractStatus("Reservation not released");
		
		System.out.println("Customer list: ");
		for(Iterator iter = rentalSystem.getIterator("customer"); iter.hasNext();)
		{
        Customer cobj = (Customer) iter.next();
        System.out.println(cobj.toString());
    }
		
		System.out.println("Exec list: ");
		for(Iterator iter = rentalSystem.getIterator("exec"); iter.hasNext();)
		{
        Exec cobj = (Exec) iter.next();
        System.out.println(cobj.toString());
    }
		
		System.out.println("Vehicle list: ");
		for(Iterator iter = rentalSystem.getIterator("vehicle"); iter.hasNext();)
		{
        Vehicle cobj = (Vehicle) iter.next();
        System.out.println(cobj.toString());
    }
		
		System.out.println("Reservation list: ");		
		for(Iterator iter = rentalSystem.getIterator("Reservation"); iter.hasNext();)
		{
        Reservation cobj = (Reservation) iter.next();
        System.out.println(cobj.toString());
    }
		rentalSystem.visitOffice(rentalSystem.robj[0]);
	}	
}

</pre>
        </div>


       </div>
    </div>
  </main>
</template>

<style scoped>
* {
  box-sizing: border-box;
  background-color: #F9FAFE;
}

h1,
h2,
p {
  font-family: sans-serif;
  color: rgb(0, 3, 40);
}

.column {
  float: left;
  width: 50%;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}


mark1 {
  background-color: rgb(176, 230, 183);
  box-shadow: 1px 6px 15px 2px rgb(160, 222, 159);
  color: black;
  border-radius: 10px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
}

mark0 {
  box-shadow: 1px 6px 15px 2px rgb(249, 255, 191);
  background-color: rgb(231, 238, 162);
  color: black;
  border-radius: 10px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
}

#comment {
  margin-left: 15px;
  font-style: italic;
  color: gray;
  font-size: small;
}


.codebox {
  height: 80%;
  width: fit-content;
  min-width: 90%;
  margin: 25px;
  padding: 25px;
  border-radius: 10px;
  background-color: #F9FAFE;
  box-shadow: 2px 3px 10px 2px #D7DFFF;
}

input {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  color: black;
}

/* CSS */
.button-9 {
  appearance: button;
  backface-visibility: hidden;
  background-color: #405cf5;
  border-radius: 6px;
  border-width: 0;
  box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .1) 0 2px 5px 0, rgba(0, 0, 0, .07) 0 1px 1px 0;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  font-family: -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif;
  font-size: 100%;
  height: 44px;
  line-height: 1.15;
  margin: 12px 0 0;
  outline: none;
  overflow: hidden;
  padding: 0 25px;
  position: relative;
  text-align: center;
  text-transform: none;
  transform: translateZ(0);
  transition: all .2s, box-shadow .08s ease-in;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 200px;
}

.button-9:disabled {
  cursor: default;
}

.button-9:focus {
  box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .2) 0 6px 15px 0, rgba(0, 0, 0, .1) 0 2px 2px 0, rgba(50, 151, 211, .3) 0 0 0 4px;
}

#snackbar {
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 30px;
  font-size: 17px;
}

#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
</style>
 